import React, { useEffect, useState } from "react";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, query, where, getDocs, updateDoc, doc } from "firebase/firestore";
import "./viewapplication.css";

function ViewApplication() {
  const [submits, setSubmits] = useState([]);
  const [loading, setLoading] = useState(true);
  const auth = getAuth();
  const db = getFirestore();

  useEffect(() => {
    const fetchSubmits = async () => {
      const user = auth.currentUser;
      if (!user) {
        setLoading(false);
        return;
      }

      const userEmail = user.email;
      const submissionRef = collection(db, "formSubmissions");
      const q = query(submissionRef, where("email", "==", userEmail));

      try {
        const querySnapshot = await getDocs(q);
        const submissionList = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
        }));
        setSubmits(submissionList);
      } catch (error) {
        console.error("Error fetching submissions:", error);
      }

      setLoading(false);
    };

    fetchSubmits();
  }, []);





   // Add this function to update status in Firestore
   const updateStatus = async (submissionId, newStatus) => {
    try {
      await updateDoc(doc(db, "formSubmissions", submissionId), {
        status: newStatus,
        updatedAt: new Date()
      });
      
      // Update local state to reflect changes immediately
      setSubmits(submits.map(sub => 
        sub.id === submissionId ? { ...sub, status: newStatus } : sub
      ));
      
      alert(`Status updated to ${newStatus}`);
    } catch (error) {
      console.error("Error updating status:", error);
      alert("Failed to update status");
    }
  };





  return (
    <>
      <section className="hero">
        <div className="hero-image">
          <img src="/round-logo.png" alt="conference" />
        </div>
        <div className="hero-content">
                <h1>Eye Care Clinic & Optical</h1>
                <p>
                Providing trusted eye clinic and quality optical services since 2007, 
                our clinic is committed to enhancing eye health and improving lives through 
                expert care and advanced solutions.
                </p>
        </div>
      </section>


      <div className="submissions-container">
    <table className="submission-table">
      <thead>
        <tr>
          <th>Name</th>
          <th>NIC/Passport No</th>
          <th>Email</th>
          <th>Contact</th>
          <th>Status</th>
          <th>Submitted At</th>
          <th>Fee Type</th>
          <th>Application File</th>
          <th>Payment Slip</th>
  
        </tr>
      </thead>
      <tbody>
        {submits.map((submission) => (
          <tr key={submission.id} className="submission-row">
            <td data-label="Name">{submission.name}</td>
            <td data-label="NIC/Passport">{submission.nicPassportNo}</td>
            <td data-label="Email">{submission.email}</td>
            <td data-label="Contact">{submission.contactNo}</td>
            <td data-label="Status">
              <span className={`status-badge ${submission.status?.toLowerCase() || 'pending'}`}>
                {submission.status || 'Pending'}
              </span>
            </td>
            <td data-label="Submitted At">
              {submission.submittedAt?.toDate().toLocaleString()}
            </td>
            <td data-label="Fee Type">{submission.feeType}</td>
            <td data-label="Application File">
              <a 
                href={submission.applicationFileUrl} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="file-link"
                title={`Download application: ${submission.applicationFileName}`}
              >
                <span className="file-icon">📝</span> Application
              </a>
            </td>
            <td data-label="Payment Slip">
              <a 
                href={submission.paymentSlipUrl} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="file-link"
                title={`Download payment: ${submission.paymentFileName}`}
              >
                <span className="file-icon">💳</span> Payment
              </a>
            </td>
    
         
          </tr>
        ))}
      </tbody>
    </table>

    {loading && (
      <div className="loading-indicator">
        <div className="spinner"></div>
        <p>Loading submissions...</p>
      </div>
    )}
    
    {!loading && submits.length === 0 && (
      <div className="empty-state">
        <img src="/empty-folder.png" alt="No submissions" />
        <h3>No submissions found</h3>
        <p>There are currently no submissions to display.</p>
      </div>
    )}
  </div>






    </>
  );
}

export default ViewApplication;
